import {
  IAlbumDataManager,
  IUpdatingTagParams,
  IUpdateAlbumDateParms,
  IUpdateBulkAGAlbumParams,
  IAlbumClusterConfig,
  IOwnedAlbumPhotosParams,
  IMoveCopyMultiAssetsParamsForAgg,
} from './ialbum_data_manager';
import { AjaxHelper } from '../../http/ajax_helper';
import { IClientConfig } from '../data_manager/data_manager_factory';
import { Util } from '../../common_utils/util';
import { IRearrageUpdateParams } from './ialbum_data_manager';
import { IDeleteOwnedAlbumParams } from "./ialbum_data_manager";
import { AGTranslator } from '../translators/ag_translator';
import { AlbumClusterHelper } from './album_cluster_helper';
import { CommonAlbumsManager } from './common_albums_manager';
//import * as $ from 'jquery';
import { ITranslator } from '../translators/itranslator';

export class AGAlbumManager extends CommonAlbumsManager  implements IAlbumDataManager {
  private agTranslator: ITranslator;
  private discoveryEndPoints: any;
  clusterHelper: AlbumClusterHelper;

  /**
  *Creates an instance of AGAlbumManager and also create an
  *instance of translator if required.
  * @param {IClientConfig} config
  * @memberof AGAlbumManager
  */
  constructor(config: IClientConfig) {
    super();
    this.agTranslator = Util.getTranslatorObj(config);
    this.discoveryEndPoints = config.discoveryEndPoints;
    this.clusterHelper  = new AlbumClusterHelper();
  }

  /**
  * Method to get the album clusters meta data
  * (only months and respective cluster count)
  * @param {IAlbumClusterConfig} clusterConfig
  * @returns {Promise<any>}
  * @memberof AGAlbumManager
  */
  getAlbumsClusterMetaData(clusterConfig: IAlbumClusterConfig): Promise<any> {
    clusterConfig = this.clusterHelper.clusterConfig = $.extend(true, this.clusterHelper.clusterConfig, clusterConfig);
    let querySring = `limit=0&cskip=0&climit=${clusterConfig.limit}&timezoneOffset=${clusterConfig.timezoneOffset}&sortCriteria=${clusterConfig.sortCriteria}&sortOrder=${clusterConfig.sortOrder}`;
    if(clusterConfig.sourceList){
      querySring += "&source=" + clusterConfig.sourceList;
    }
    const url = this.discoveryEndPoints.pictService + 'v1/gw/albums/cluster?' + querySring;
    let config = {
      url,
      type: "GET",
      ignoreAToken: true
    };
    const promise = AjaxHelper.triggerApi({requestConfig: config },
      this.agTranslator.prepareAlbumPagesData.bind(this.agTranslator, this.clusterHelper)
    );
    return promise;
  }

  /**
  * Method to get the album clusters meta data
  * (only months and respective cluster count)
  * @param {string} pageUrl
  * @returns {Promise<any>}
  * @memberof AGAlbumManager
  */
  getAlbumClusters(pageUrl: string): Promise<any> {
    const url = this.discoveryEndPoints.pictService + 'v1/gw/albums/cluster?' + pageUrl;
    let config = {
      url,
      type: "GET",
      ignoreAToken: true
    };
    const promise =  AjaxHelper.triggerApi(
      {requestConfig: config}, this.agTranslator.translateAlbumClusters.bind(this.agTranslator))
    return promise;
  }
  
  /**
   *Method used to return the translator object if present or
   * will return undefined if not present       .
   * @returns {*}
   * @memberof AGAlbumManager
   */
  getTranslatorObj(): any {
    return this.agTranslator;
  }
  /**
   * Method to delete a particular album from the albums list     
   * @param {IDeleteOwnedAlbumParams} queryParamsObj
   * @returns {Promise<any>}
   * @memberof UAAlbumManager
   */
  deleteAlbum(queryParam: IDeleteOwnedAlbumParams): any {
    const url = this.discoveryEndPoints.pictService + "v1/gw/album/" + queryParam.albumId;      
    let config = {
      url,
      type: "DELETE",
      ignoreAToken: true
    };
    let promise = AjaxHelper.triggerApi({ requestConfig: config });    
    return promise;
  }
  
  /* istanbul ignore next */
  getOwnedAlbumInfo(albumId: string): any {
    // call ajax helper do ajax
    const url = this.discoveryEndPoints.pictService + 'v1/gw/album?albumId=' + albumId;
    let config = {
      url,
      type: 'GET',
      ignoreAToken: true
    };
    const translator = this.getTranslatorObj();
    let promise = AjaxHelper.triggerApi(
      { requestConfig: config },
      translator.translateAlbum.bind(translator)
    );

    return promise;
  }
  /**
   * Method to rearrange the assets in an album.   
   * @param {IRearrageUpdateParams} queryParamsObj
   * @returns {Promise<any>}
   * @memberof UAAlbumManager
   */
  reArrangeAlbum(queryParamsObj: IRearrageUpdateParams): Promise<any> {
    //https://gw.sf-qa.com/v1/gw/photo/rearrange?albumId=11044766241060
    const url = this.discoveryEndPoints.pictService + "v1/gw/photo/rearrange?albumId=" + queryParamsObj.albumId;

    let config = {
      url,
      type: "POST",
      data: queryParamsObj.payload,
      ignoreAToken: true
    };
    let promise = AjaxHelper.triggerApi(
      { requestConfig: config }
    );
    return promise;
  }
  /**
   * Method to save the sort order of an album after sorting.   
   * @param {IUpdatingTagParams} params
   * @returns {Promise<any>}
   * @memberof AGAlbumManager
   */
  updateAlbumTag(params: IUpdatingTagParams): any {
    const url = this.discoveryEndPoints.pictService + "v1/gw/album/addTags?albumId=" + params.albumId;
    //https://gw.sf-qa.com/v1/gw/album/addTags?albumId=12345
    let config = {
      url,
      type: "POST",
      data: params.payload,
      ignoreAToken: true
    };
    let promise = AjaxHelper.triggerApi({ requestConfig: config });    
    return promise;
  }
  /* istanbul ignore next */
  updateAlbumDate(param: IUpdateAlbumDateParms): any {}
  /**
   * Method to update album create data, caption and description
   * @param data 
   */
  updateAlbumByBulkCall(data: IUpdateBulkAGAlbumParams): Promise<any> {
    const url = this.discoveryEndPoints.pictService + '/v1/gw/albums/bulk';
    const promise = AjaxHelper.triggerApi({requestConfig:  {url, type: 'POST',ignoreAToken: true, data: JSON.stringify(data) } }, this.agTranslator.translateBulkApiAlbumResponse.bind(this.agTranslator, data));    

    return promise;
  }
  /**
   *Method to get all the assets of a single album, it is used for favorites album as well.
   * NOTE: Based on "isTranslationRequired" params we decide to keep the pascal format for asset
   * isTranslationRequired is basically used in global upload confirmation, to get pascal format models and pass to builder
   * @param {IOwnedAlbumPhotosParams} paramObj
   * @returns {Promise<any>}
   * @memberof AGAlbumManager
   */
  getOwnedAlbumPhotos(paramObj: IOwnedAlbumPhotosParams): Promise<any> {
    // call ajax helper do ajax
    // GET /v1/gw/album/{albumId}/photos?sortCriteria=createDate&limit=10&skip=10&sortOrder=asc|desc

    //converting skip, limit key/values to page, size values as pascal api know only page and limit keys.
    if (paramObj.limit) {
      paramObj.size = paramObj.limit;
      paramObj.page = 0;
      if (paramObj.skip && paramObj.skip > 0) {
        paramObj.page = paramObj.skip / paramObj.limit;
      }
    }
    let url = "";
    const agTranslator = this.getTranslatorObj();
    //Default translator for owned photos call.
    let translatorCallBack = agTranslator.translateOwnedAlbumPhotos.bind(agTranslator,paramObj.isTranslationRequired);
    if(paramObj.albumId === "FAVORITES"){//The album id is set as FAVORITES at the library end.      
      url =
      this.discoveryEndPoints.pictService +
      'v1/gw/photos/favorites?' +
      Util.prepareParamString(paramObj, ['albumId','skip', 'limit','isTranslationRequired']);
      translatorCallBack = agTranslator.translateFavoriteAlbumPhotos.bind(agTranslator);
    }else{//Other owned albums assets flow.
      //For only first page, we get the favorite images as well as it contians all fav images of the album.
      const getFavoriteImagesParam = (paramObj.page == 0) ? "favoritesView=true&" : "";
      url =
      this.discoveryEndPoints.pictService +
      'v1/gw/album/' +
      paramObj.albumId +
      '/photos?' + getFavoriteImagesParam +
      Util.prepareParamString(paramObj, ['albumId', 'skip', 'limit','isTranslationRequired']);
    }
    const config = {
      url,
      type: 'GET',
      ignoreAToken: true
    };    
    let promise = AjaxHelper.triggerApi(
      { requestConfig: config },
      translatorCallBack
    );
    return promise;
  }

   /**
   * Method to get the shared token by album id.   
   * @param {string} payload
   * @returns {Promise<any>}
   * @memberof UAAlbumManager
   */
  getShareTokenForAlbum(payload: string): Promise<any> {
    return super.getShareTokenForAlbum(this.discoveryEndPoints.uaPictService, payload);
  }

  /**
    * Method to create a new album with the added assets.   
    * @param {string} payload
    * @returns {Promise<any>}
    * @memberof UAAlbumManager
    */
  createAlbum(payload: string): Promise<any> {
    return super.createAlbum(this.discoveryEndPoints.uaPictService, payload);
  }
  
  /**
   * Method to get all the albums. 
   * @returns {Promise<any>}
   */
  getCollectionList(clusterConfig: IAlbumClusterConfig): Promise<any> {
    const agTranslator = this.getTranslatorObj();
    //Default translator for owned photos call.
    let translatorCallBack = agTranslator.prepareCollectionListInfo;
    clusterConfig = this.clusterHelper.clusterConfig = $.extend(true, this.clusterHelper.clusterConfig, clusterConfig);
    let querySring = `limit=0&cskip=0&climit=2000&timezoneOffset=${clusterConfig.timezoneOffset}&sortCriteria=${clusterConfig.sortCriteria}&sortOrder=${clusterConfig.sortOrder}&source=snapfish`;
    const url = this.discoveryEndPoints.pictService + 'v1/gw/albums/cluster?' + querySring;
    let config = {
      url,
      type: "GET",
      ignoreAToken: true
    };
    const promise = AjaxHelper.triggerApi({requestConfig: config },
      translatorCallBack.bind(agTranslator)
    );
    return promise;
  }

  /**
   * move or copy multiple assets to existing or new album
   * @param isMovePhotos
   * @param data 
   */
  moveOrCopyToAlbum(params:IMoveCopyMultiAssetsParamsForAgg): Promise<any> {
    let url = this.discoveryEndPoints.pictService + '/v1/gw/album/copy';
    if (params.movePhotos) {
      url = this.discoveryEndPoints.pictService + '/v1/gw/album/move';
    }
    const config = { url, type: 'POST', data: JSON.stringify(params.data),ignoreAToken: true }
    let promise = AjaxHelper.triggerApi({ requestConfig: config });
    return promise;
  } 


}
